<template>
  <div class="layout-page">
    <bottom></bottom>
    <div class="cat-head">
      <ul class="cat-list">
<!--        <li-->
<!--          v-for="(item) in category.channelList"-->
<!--          :key="item.code"-->
<!--          @click="changeChannel(item.code)"-->
<!--          :class="{ active: getChannelActive === item.code}"-->
<!--        >-->
<!--          <a v-if="item.code=='A'">{{ item.desc }}频道</a>-->
<!--          <a v-else>{{ item.desc }}</a>-->
<!--        </li>-->
      </ul>
      <ul class="cat-list">
        <li
          v-for="(item) in category.publishStatusList"
          :key="item.code"
          @click="changePublishStatus(item.code)"
          :class="{ active: getPublishActive === item.code}"
        >
          <a v-if="item.code=='all'">{{ item.desc }}状态</a>
          <a v-else>{{ item.desc }}</a>
        </li>
      </ul>
      <ul class="cat-list">
        <li
          v-for="(item) in category.categoryList"
          :key="item.id"
          @click="changeCategory(item.id)"
          :class="{ active: getCategoryActive === item.id}"
        >
          <a v-if="item.id==0">{{ item.name }}</a>
          <a v-else>{{ item.name }}</a>
        </li>
      </ul>
    </div>
    <div class="aui-scrollView" id="scroll-div-category">

      <div class="cat-content">
        <van-list
          ref="vanList"
          v-model="loading"
          :finished="finished"
          :finished-text="finishedText"
          @load="getBooks"
        >
          <books-large :show-title="false" :books="books"></books-large>
          <van-empty v-if="books.length === 0 && finished" description="暂无数据"/>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
import BooksLarge from '@/components/share/books-large'
import Bottom from '@/components/layer1/bottom'

import listService from '../../services/listService'

export default {
  name: 'category',
  data () {
    return {
      componentName: '',
      category: {
        publishStatusList: [],
        categoryList: [],
        channelList: []
      },
      selected: {
        channel: 'A',
        category: 0,
        publish: 'all'
      },
      loading: false,
      finished: false,
      finishedText: '',
      currentPage: 1,
      books: []
    }
  },
  computed: {
    getPublishActive () {
      return this.selected.publish
    },
    getCategoryActive () {
      return this.selected.category
    },
    getChannelActive () {
      return this.selected.channel
    }
  },
  methods: {
    getCategory () {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true
      })
      listService.getCategory().then(res => {
        this.category = res.data
        this.$toast.clear()
      }).catch(() => {
        this.$toast.clear()
      })
    },
    resetData () {
      this.finished = false
      this.loading = false
      this.books = []
      this.currentPage = 1
      this.$refs.vanList.check()
    },
    changePublishStatus (code) {
      this.selected.publish = code
      this.resetData()
    },
    changeCategory (id) {
      this.selected.category = id
      this.resetData()
    },
    changeChannel (code) {
      this.selected.channel = code
      this.resetData()
    },
    getBooks () {
      const { finished, books, currentPage } = this
      const { category, publish, channel } = this.selected
      if (finished) return
      listService
        .getBooks(category, currentPage, publish, channel)
        .then(res => {
          const resData = res.data
          const bookList = resData.bookList || []
          this.loading = false
          this.books = books.concat(bookList)
          if (currentPage >= resData.totalPage || bookList.length === 0) {
            this.finished = true
            if (this.books.length > 6) {
              this.finishedText = '没有更多了'
            } else {
              this.finishedText = ''
            }
          } else {
            this.currentPage++
          }
        })
    }
  },
  components: {
    'books-large': BooksLarge,
    bottom: Bottom
  },
  mounted () {
    this.componentName = this.$route.name
    //   this.$router.isBack
    if (
      this.$store.state.pageState[this.componentName]
    ) {
      Object.assign(
        this.$data,
        this.$store.state.pageState[this.$route.name].data
      )
      setTimeout(() => {
        const scrollDiv = document.getElementById('scroll-div-category')
        scrollDiv.scrollTop = this.$store.state.pageState[this.$route.name].top
      }, 0)
    } else {
      this.getCategory()
      // this.getBooks(1)
    }
    this.$router.isBack = true
  },
  beforeDestroy () {
    const scrollDiv = document.getElementById('scroll-div-category')
    const state = {}
    state[this.componentName] = { data: this.$data, top: scrollDiv.scrollTop }
    this.$store.commit('saveState', state)
  }
}
</script>

<style>
</style>
